
var protocol = location.protocol;
var slashes = protocol.concat("//");

export const HOST = slashes.concat(window.location.href.split("/")[2]);
export const ROOT_URL = HOST
export const THUMB_URL = ( ROOT_URL + '/superadmin/cockpit/utils/thumb_url' ).replace('3000', '')
export const API_URL = HOST.replace('3000', '') + '/superadmin/api'
export const TOKEN = 'c00095a41ede59b046a8e9745288a6'


// WEBPACK FOOTER //
// ./src/etc/constants.js